import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiError, BaseVisualizacaoService, DataTablesService, MessageService, VisualizacaoStorageService } from '../../core';
import { CidadeCrudHttpService } from './services';

import { Cidade } from './cidade';
import { CidadeFilter, CidadeFilterCollapseComponent } from './filter';
import { CidadeClassificacaoAbcPipe } from './pipes';

@Component({
    selector: 'sgt-cidade',
    templateUrl: './cidade.component.html',
    styleUrls: ['./cidade.component.less']
})
export class CidadeComponent implements OnInit {
    entities: Cidade[];
    idDataTable = '#tableCidades';
    dataTable: any;

    filter = new CidadeFilter();
    @ViewChild('filterCollapse', {static: true}) filterCollapse: CidadeFilterCollapseComponent;
    @ViewChild('containerTable') containerTable: ElementRef;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private cidadeCrudHttpService: CidadeCrudHttpService,
                private cidadeClassificacaoAbcPipe: CidadeClassificacaoAbcPipe) { }


    ngOnInit() {
        // Aplicando o filtro armazenado no filtro avançado
        this.baseVisualizacaoService.aplicarFiltroArmazenado(this.filter, this.filterCollapse);
        // Obtendo os dados armazenados da visualização
        const vs = this.visualizacaoStorageService.get();
        // Criando a dataTable assíncrona
        this.createTable().then(() => {
            // Se possuir dados armazenados, então aplicamos eles na dataTable
            if (vs != null) {
                this.dataTable.search(vs.filterSearch)
                                .page(vs.currentPage)
                                .order(vs.order)
                                .draw(false);
            }
        });
    }

    search() {
        this.dataTable.ajax.reload();
        this.filterCollapse.close();
        jQuery(this.containerTable.nativeElement).scrollTop(0);
    }

    clear() {
        this.filterCollapse?.clear();
        this.dataTable?.search('');
    }


    private afterSearch() {
        // Setando o filtro, a página e a ordenação atual da tabela nos dados armazenados da visualização
        this.visualizacaoStorageService.set(this.filter, this.dataTable.search(), this.dataTable.page.info().page, this.dataTable.order());
    }

    showTable() { }

    /** Cria a Datatables assíncrona */
    createTable(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.dataTablesService.showTable(this.idDataTable, this.dataTable, {
                order: [[2, 'asc']],
                serverSide: true,
                processing: true,
                columns: [
                    {
                        data: null,
                        className: 'col-options',
                        render: (entity: Cidade) => {
                            let template = `
                                <a id="edit" title="Editar"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>
                            `

                            if (entity?.cadastroManual) {
                                template += `
                                    <a id="delete" title="Excluir"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
                                `;
                            }

                            return template;
                        },
                    },
                    {data: 'codigoIbge', className: 'col-codigo-ibge'},
                    {data: 'nome', className: 'col-nome'},
                    {data: 'estado.uf', className: 'col-estado text-center'},
                    {data: 'classificacao', className: 'col-classificacao text-center', render: (data) => this.cidadeClassificacaoAbcPipe.transform(data)}
                ],
                ajax: (data, callback, settings) => { // Evento Ajax para pesquisar os clientes
                    const order = data.order[0];
                    this.filter.nome = data.search.value;
                    this.cidadeCrudHttpService.searchWithFilter(this.filter, data.draw, data.start, data.length, order.column, order.dir)
                        .subscribe(
                            response => {
                                this.entities = response.data;
                                this.afterSearch();
                                callback(response);
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar as cidade', error);
                                this.afterSearch();
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        );
                }
            })
            .then(dataTable => {
                this.dataTable = dataTable;

                // Vinculando os eventos de click das opções da tabela
                const myself = this;
                $(`${this.idDataTable} tbody`).on( 'click', 'a', function() {
                    const table = ($(myself.idDataTable) as any).DataTable();
                    const data = table.row($(this).parents('tr')).data();

                    if (this.id === 'edit') {
                        myself.edit(data);
                    } else if (this.id === 'delete') {
                        myself.delete(data);
                    }
                } );

                setTimeout(() => resolve(), 500);
            });

        });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: Cidade) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: Cidade) {
        this.messageService.confirm(`Deseja realmente excluir a cidade: ${entity.nome}?`).then(result => {
            if (result) {
                this.cidadeCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir a cidade: ${entity.nome}`, error)
                    );
            }
        });
    }
}
